import React from 'react';

import { useHistory } from 'react-router';
import { useAnalytics } from '../../../common/RudderStack';
import Button from '../../../common/navigation/Button';

const CardFree: React.FC<{ displayRedirectionButton?: boolean, taken?: boolean }> = ({
  displayRedirectionButton = false,
  taken = false,
}) => {
  const history = useHistory();
  const analytics = useAnalytics();

  const freeSubscription = () => {
    analytics?.track('Free Subscription');
    history.push('/consultation_open#tour');
  };

  return (
    <div className="card price-request-card-subscription-free price-request-card-plan card-plan-free subscription-plan mb-3">
      <div className="price-request-header-title">
        <span></span>
      </div>
      <div className="card-title pb-3">
        <h3>Creation de compte</h3>
      </div>
      <h1>
        0<sup className="large">€HT</sup>
      </h1>
      <div className="card-title">
        <h3 className="mb-3">
          <strong>Formule d&apos;essai</strong>
        </h3>
      </div>
      {displayRedirectionButton && (
        <div className="button" style={{ position: 'absolute', bottom: 20, left: 10, right: 10 }}>
          <button
            type="button"
            className="btn btn-outline-primary"
            onClick={() => freeSubscription()}
          >
            S&apos;INSCRIRE
          </button>
        </div>
      )}
      <p className="subtitle-request-price">Découvrez tous les projets :</p>
      <ul className="check-list-price-request">
        <li className="icon-free">Par départements</li>
        <li className="icon-free">Par lots</li>
        <li className="icon-free">Par secteur d’activité</li>
        <li className="cancel-icon-free">Sans accès à la maîtrise d’ouvrage</li>
        <li className="cancel-icon-free">Sans accès aux DCEs</li>
        <li className="cancel-icon-free">Sans possibilité de réponse</li>
        <li className="cancel-icon-free">Sans formation personnalisée à l’outil</li>
      </ul>
      <div className="button">
        {
          !taken
            ? (<Button
              color="btn-free-pack"
              text={'Finaliser mon compte'}
              action={() => freeSubscription()}
            />)
            : (<Button
              disabled
              color="btn-free-pack"
              text={'Formule actuelle'}
              action={() => null}
            />)
        }
      </div>
    </div>
  );
};

export default CardFree;
